// record-custom.js 
recodestudios.APIKey = "df6f6d5fe87011ce6b4a127e3aa31b54273ace4d";
recodestudios.tryOnAPI = function(data){
  $.ajax({
    url : "https://recode.selfstylo.com/api/try_on",
    type : "post",
    headers : {'Authorization':'Token ' + recodestudios.APIKey},
    data : JSON.stringify(data),
    success : function(response) {
      setTimeout(() => {
        $("#try_on_model").empty();
        $("#try_on_model").html(response['iframe_html'])
      }, 2000);
    },
    error : function(XMLHttpRequest, textStatus, errorThrown){
      alert("This is not Found");
    }
  })
}


$(document).ready(function(){
  setTimeout(() => {
    $(".try-on-button").show();
  }, 1000);
  $(document).on("click",".try-on-button",function(){
    var productShade;
    $(this).text("Opening Try On...");
    var collection_handle = $(this).attr("data-product-collection-handle"), data;
    if($(this).attr("data-productshade") != '' ){
      productShade = $(this).attr("data-productshade");
    } else {
      productShade = '';
    }
    if(collection_handle == 'eyeliner'){
      data = {
        "payload" : {
          "Eyeliner" : {
            "color" : "rgb(115,0,15)",
            "name" : productShade,
            "sku" : ""
          }
        }
      }
    } else if(collection_handle == "foundation") {
      data = {
        "payload" : {
          "Foundation" : {
            "color" : "rgb(115,0,15)",
            "name" : productShade,
            "sku" : ""
          }
        }
      }
    } else {
      data = {
        "payload" : {
          "Lipstick" : {
            "color" : "rgb(115,0,15)",
            "name" : productShade,
            "sku" : ""
          }
        }
      }
    }
    $("#try_on_model").addClass("open_popup");
    $("#try_on_model").html("<div class='iframe-empty-msg-container'>Preparing Try on studio for you.....</div>");
    $('html,body').css({
      "overflow": "hidden"
    })
    recodestudios.tryOnAPI(data);
  })
})